<script>
  // @ts-check
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";

  import Form from "$lib/components/Form.svelte";

  import {
    buildFormFields,
    buildFormFieldGroups,
    buildCta,
    buildDefaultFormFields
  } from "$lib/utilities/contentTypes/form";
  import { getFullUrl } from "$lib/utilities/url-helpers";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let data;
  export let result = null;
  export let formSubmitErrorMessage = "";
  export let canSubmit = true;

  const {
    id,
    provider,
    layout,
    title,
    description,
    confirmationTitle,
    confirmationSubtitle,
    confirmationDescription,
    confirmationCta,
    redirectUrl
  } = data?.fields || {};

  const formFields = buildFormFields(data?.fields).concat(
    buildDefaultFormFields(data?.fields, $page?.url)
  );

  const formFieldGroups = buildFormFieldGroups(data?.fields);
  const confirmation = {
    title: confirmationTitle,
    subtitle: confirmationSubtitle,
    description: confirmationDescription,
    cta: buildCta(confirmationCta)
  };
  const fullRedirectUrl = getFullUrl(redirectUrl, $page?.url?.origin);
  const imageFields = data?.fields?.featuredImage?.fields;
  const theme = data?.fields?.theme || "lightGrey";
</script>

<Form
  on:submit
  class={className}
  {id}
  {provider}
  {layout}
  {theme}
  {title}
  {description}
  image={imageFields}
  {formFields}
  {formFieldGroups}
  bind:result
  {confirmation}
  {canSubmit}
  {formSubmitErrorMessage}
  redirectUrl={fullRedirectUrl}
/>
